import type { IntentFilters } from "@/store/companyPageStore";
import type { CompanyFilters } from "../types";

/**
 * Transforms CompanyFilters.intent from Segments to IntentFilters for CompanyDrawer.
 * Only passes the essential filter values; other fields use defaults.
 */
export function toCompanyProfileIntentFilters(
  filters: CompanyFilters | undefined
): IntentFilters {
  if (!filters?.intent) {
    return {
      topicIds: [],
      topicsCache: [],
      buyersJourneyIds: [],
      contextTypeIds: [],
      locationCountryAlpha2s: [],
      locationStateIds: [],
      locationRegionNames: [],
      includeCorporateDescendants: false,
      numberOfCadences: 6,
      techTopicsOnly: false,
    };
  }

  const { intent } = filters;

  return {
    topicIds:
      intent.topics?.ids?.filter((id): id is string => id != null) ?? [],
    topicsCache: [],
    buyersJourneyIds:
      intent.buyersJourneyIds?.filter((id): id is string => id != null) ?? [],
    contextTypeIds:
      intent.contextTypeIds?.filter((id): id is string => id != null) ?? [],
    locationCountryAlpha2s:
      intent.location?.countryAlpha2s?.filter((c): c is string => c != null) ??
      [],
    locationStateIds:
      intent.location?.stateIds?.filter((s): s is string => s != null) ?? [],
    locationRegionNames:
      intent.location?.regionNames?.filter((r): r is string => r != null) ?? [],
    includeCorporateDescendants: false,
    numberOfCadences: 6,
    techTopicsOnly: false,
  };
}
